import { forwardRef } from 'react';

/**
 * The scrolling frame and the table. `drill` is what gives sub-rows their
 * indent and rule; `drill-scroll` lets a wide table scroll sideways inside its
 * card instead of breaking the page. The ref is the scroller, for a caller that
 * wants to start it scrolled to one end. `minWidth` makes a wide table scroll
 * rather than squeeze.
 */
export const DrillTable = forwardRef(function DrillTable({ children, className, minWidth }, ref) {
  return (
    <div className="drill-scroll" ref={ref}>
      <table className={className ? `drill ${className}` : 'drill'} style={minWidth ? { minWidth } : undefined}>
        {children}
      </table>
    </div>
  );
});
